import {
  checkPhoneNumberRequestSchema,
  checkPhoneNumberResponseSchema,
  geoCountryResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const endpoints = {
  'phoneNumber.check': {
    method: 'POST',
    url: `${API_URL_BASE}checkPhoneNumber`,
    requestSchema: checkPhoneNumberRequestSchema,
    responseSuccessSchema: checkPhoneNumberResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof checkPhoneNumberRequestSchema,
    typeof checkPhoneNumberResponseSchema,
    z.ZodUndefined
  >,
  'geo.country': {
    method: 'GET',
    url: `${API_URL_BASE}geo/country`,
    requestSchema: z.undefined(),
    responseSuccessSchema: geoCountryResponseSchema,
    requiresToken: 'none',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof geoCountryResponseSchema,
    z.ZodUndefined
  >,
};

export default endpoints;
